// Import package from Soil plugin example.
import $ from "@modules/jquery";

$(function () {
  mtmAccordionEvents();

  $("nav#menu")
    .find("*")
    .each(function () {
      $(this).removeAttr("role aria-haspopup aria-label");
    });
});

$(window).on("changed.zf.mediaquery", function (e, target) {
  mtmAccordionEvents();
});

// Piwik integration
// Slide 6
function mtmAccordionEvents() {
  $("[data-accordion]")
    .off("down.zf.accordion")
    .on("down.zf.accordion", function (e, target) {
      dataLayer.push({
        event: "interaction.generic.component.accordion",
        meta: {
          action: "open",
          label: `${target.prev().text().trim()} - ${window.location.href}`,
        },
      });
    });
  $("[data-accordion]")
    .off("up.zf.accordion")
    .on("up.zf.accordion", function (e, target) {
      dataLayer.push({
        event: "interaction.generic.component.accordion",
        meta: {
          action: "close",
          label: `${target.prev().text().trim()} - ${window.location.href}`,
        },
      });
    });
}

// Slide 7
$('a[target="_blank"]').on("click", function (e) {
  const linkTitle = $(this).attr("title") || $(this).text();
  dataLayer.push({
    event: "interaction.generic.component.outboundLinkClick",
    meta: {
      action: `${linkTitle} - ${$(this).attr("href")}`,
      label: window.location.href,
    },
  });
});

// Slide 8
$('a:not([target="_blank"])[href^="http"]').on("click", function (e) {
  const linkTitle = $(this).attr("title") || $(this).text();
  dataLayer.push({
    event: "interaction.generic.component.internalLinkClick",
    meta: {
      action: `${linkTitle} - ${$(this).attr("href")}`,
      label: window.location.href,
    },
  });
});

$(function () {
  if ($("body.search-results").length < 1) {
    return;
  }

  // Slide 9
  const searchTerm = $("input#search-field");
  const searchResultCount = $(".search-results-count .count");

  dataLayer.push({
    event: "interaction.component.searchExecution",
    meta: {
      search_term:
        typeof searchTerm[0] !== "undefined" ? searchTerm[0].value : "-",
      search_result_amount:
        typeof searchResultCount[0] !== "undefined"
          ? parseInt(searchResultCount[0].textContent)
          : 0,
      search_type: "manueel",
    },
  });

  // Slide 10
  const a = $("a.search-result-link");
  a.on("click", function (e) {
    const searchTerm = $("input#search-field");
    const searchResultCount = $(".search-results-count .count");
    const searchResultTitle = $(this).siblings("h4")[0]?.textContent;

    dataLayer.push({
      event: "interaction.component.searchResult",
      meta: {
        search_term:
          typeof searchTerm[0] !== "undefined" ? searchTerm[0].value : "-",
        search_result_title: searchResultTitle,
        search_result_url: $(this).attr("href"),
        search_result_selected: a.index(this) + 1,
        search_result_filter: "geen",
        search_result_page: getPageFromUrl(window.location.href),
        search_result_amount:
          typeof searchResultCount[0] !== "undefined"
            ? parseInt(searchResultCount[0].textContent)
            : 0,
        search_type: "manueel",
      },
    });
  });
});

// Slide 11
$(function () {
  if ($("body.search-no-results").length < 1) {
    return;
  }

  const searchTerm = $("input#search-field");

  dataLayer.push({
    event: "interaction.component.searchNoResults",
    meta: {
      search_term:
        typeof searchTerm[0] !== "undefined" ? searchTerm[0].value : "-",
      search_result_amount: 0,
      search_type: "manueel",
    },
  });
});

// Slide 12
$('a[href*="dl.ggdafspraak.nl"]').on("click", function (e) {
  const linkTitle = $(this).attr("title") || $(this).text();
  dataLayer.push({
    event: "interaction.generic.component.download",
    meta: {
      action: `${linkTitle.trim()} - ${$(this).attr("href")}`,
      label: window.location.href,
    },
  });
});

// Slide 14
$(document).on("ggd_form_submitted", function () {
  dataLayer.push({
    event: "interaction.generic.component.formSubmit",
    meta: {
      vpv_url:
        window.location.pathname +
        window.location.search +
        window.location.hash,
      action: $("h1")[0].textContent,
      label: window.location.href,
    },
  });
});

// Slide [...]
// if (typeof __flowai_webclient_events !== "undefined") {
//   __flowai_webclient_events.addListener("connected", function () {
//     dataLayer.push({
//       event: "interaction.generic.component.digitalAssistant",
//       meta: {
//         action: "open",
//         label: window.location.href,
//       },
//     });
//   });
//   __flowai_webclient_events.addListener("disconnected", function () {
//     dataLayer.push({
//       event: "interaction.generic.component.digitalAssistant",
//       meta: {
//         action: "close",
//         label: window.location.href,
//       },
//     });
//   });
//   __flowai_webclient_events.addListener("send", function (message) {
//     dataLayer.push({
//       event: "interaction.generic.component.digitalAssistant",
//       meta: {
//         action: "start",
//         label: window.location.href,
//       },
//     });
//   });
// }

function getPageFromUrl(url) {
  const match = url.match(/(?:\/page\/|[?&]paged=)([1-9]\d*)/);
  if (match) {
    return Number(match[1]);
  }
  return 1;
}

function handleYouTubeEmbed(id) {
  var Embeds = Embeds || {};

  window.onYouTubeIframeAPIReady = function () {
    setTimeout(Embeds[`yt_${id}`].onYouTubeIframeAPIReady, 500);
  };

  Embeds[`yt_${id}`] = {
    interval: "",
    done25: false,
    done50: false,
    done75: false,

    init: function () {
      Embeds[`yt_${id}`].loadApi();
    },

    loadApi: function () {
      var j = document.createElement("script"),
        f = document.getElementsByTagName("script")[0];
      j.src = "//www.youtube.com/iframe_api";
      j.async = true;
      f.parentNode.insertBefore(j, f);
    },

    onYouTubeIframeAPIReady: function () {
      window.YT = window.YT || {};
      if (typeof window.YT.Player === "function") {
        var player = new window.YT.Player(`player-${id}`, {
          width: "640",
          height: "390",
          videoId: id,
          events: {
            onStateChange: Embeds[`yt_${id}`].onPlayerStateChange,
            onError: Embeds[`yt_${id}`].onPlayerError,
            onReady: setTimeout(Embeds[`yt_${id}`].onPlayerReady, 4000),
          },
          playerVars: {
            disablekb: 1,
          },
        });
      }
    },

    onPlayerStateChange: function (e) {
      if (e.data !== YT.PlayerState.PLAYING) {
        clearInterval(Embeds[`yt_${id}`].interval);
      }
      if (e.data === YT.PlayerState.PLAYING) {
        Embeds[`yt_${id}`].interval = setInterval(function () {
          Embeds[`yt_${id}`].checkPlayer(e);
        }, 2500);
        Embeds[`yt_${id}`].track("videoStart", e);
      }
      if (e.data === YT.PlayerState.PAUSED) {
        Embeds[`yt_${id}`].track("videoPauze", e);
      }
      if (e.data === YT.PlayerState.ENDED) {
        Embeds[`yt_${id}`].done25 = false;
        Embeds[`yt_${id}`].done50 = false;
        Embeds[`yt_${id}`].done75 = false;
        Embeds[`yt_${id}`].track("videoProgress100%", e);
      }
    },

    checkPlayer: function (e) {
      var p = e.target.getCurrentTime();
      var d = e.target.getDuration();
      var c = (p / d) * 100;
      c = Math.round(c);

      if (e.target.isReset) {
        c = 0;
        Embeds[`yt_${id}`].done25 = false;
        Embeds[`yt_${id}`].done50 = false;
        Embeds[`yt_${id}`].done75 = false;
      }

      if (!e.target.completed) {
        if (c >= 25 && !Embeds[`yt_${id}`].done25) {
          Embeds[`yt_${id}`].done25 = true;
          Embeds[`yt_${id}`].track("videoProgress25%", e);
        }
        if (c >= 50 && !Embeds[`yt_${id}`].done50) {
          Embeds[`yt_${id}`].done50 = true;
          Embeds[`yt_${id}`].track("videoProgress50%", e);
        }
        if (c >= 75 && !Embeds[`yt_${id}`].done75) {
          Embeds[`yt_${id}`].done75 = true;
          Embeds[`yt_${id}`].track("videoProgress75%", e);
        }
      }
    },

    // Slide 13
    track(event, e) {
      var data = e.target.getVideoData();
      var title = data.title;
      var url = "https://www.youtube.com/watch?v=" + data.video_id;
      dataLayer.push({
        event: "interaction.generic.component.videoInteraction",
        meta: {
          action: title + " - " + event + " - " + url,
          label: window.location.href,
        },
      });
    },
  };

  Embeds[`yt_${id}`].init();
}

window.handleYouTubeEmbed = handleYouTubeEmbed;
